
import React from 'react';
import AMCConstants from './AMCConstants';
import ZProps from './zprops';
import ZLog from './zlog';
import AMC from './AMC';
import { APP } from './App';
import { ROUTER } from "./AMCRouter";
import ZUtil from './zutil';
import { RockContextMenuItem } from './rs';
import PleaseStandBy from "./PleaseStandBy";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faPlay, faUndoAlt, faRedoAlt, faList, faCodeBranch, faEdit, faExternalLinkAlt, faUserNinja, faArrowRight } from '@fortawesome/free-solid-svg-icons'


export default class ZooTop extends React.Component {
	constructor(props) {
		super(props);
		let cookies = ZUtil.getCandy("zootop");
		cookies = cookies ? JSON.parse(cookies) : {};
		this.state = {};
	}
	componentDidMount() {
		APP.setTitle("Zoo");
		AMC.track(AMCConstants.ZOOTOP_TRACKING_URI);
		AMC.loadDemos((err, list) => {
			this.setState({ items: list });
		});
		// ZNetwork.get("things", this.props.target_user_uri || ZProps.get("user").uri, (err, things) => {
		AMC.loadMyThings((err, mythings) => {
			this.setState({ myitems: mythings });
		});
		this.accel_keys = [];
		this.accel_keys.push(APP.registerAcceleratorKey(false, "ArrowRight", AMC.cycleTheme));
		this.accel_keys.push(APP.registerAcceleratorKey(false, "ArrowLeft", () => AMC.cycleTheme(-1)));
	}
	componentWillUnmount() {
		APP.unregisterAcceleratorKeys(this.accel_keys || []);
		APP.setTitle(null);
	}	
	onWidgetMenu = (widget, e) => {
		if (e.preventDefault) {
			e.preventDefault();
			e.stopPropagation();
		}
		let context = { x: e.clientX, y: e.clientY, item: widget, deletable: true };
		APP.showPopup(<ZooTopWidgetMenu context={context} ed={this} />, "transparent");
		this.onWidgetSelect(widget.uri, true, true);
	}
	onBackgroundMenu = (e) => {
		e.preventDefault();
		e.stopPropagation();
		let context = { x: e.clientX, y: e.clientY, transman: this };
		let backgroundmenu = <ZooTopBackgroundMenu context={context} ed={this} />
		APP.showPopup(backgroundmenu, "transparent");
	}
	closeMenus = (e) => {
		if (e) {
			// let thru to close mainmenu
			//e.preventDefault();
			//e.stopPropagation();
		}
		APP.closePopups(null);
		this.onWidgetDeselectAll();
console.error("closeMenus and deselect all");
	}
	onWidgetSelect = (uri) => {
		this.setState({ selected: uri });
	}
	onWidgetDeselectAll = () => {
		this.setState({ selected: null });
	}
	// Currently sets text in search textfield
	setTitle(title) {
		this.setState({ title: title });
	}
	hasUndo = () => {
	}
	hasRedo = () => {
	}
	onUndo = () => {
		this.forceUpdate();
	}
	onRedo = () => {
		this.forceUpdate();
	}
	render() {
		let { items, myitems, selected } = this.state;
		ZLog.debug("RENDER zootop");
		if (!items) {
			return <PleaseStandBy />;
		}
		let widgets = (items || []).filter(x => !!x).map( s => { 
			return <ZooTopWidget key={s.uri} item={s} onWidgetMenu={this.onWidgetMenu} selected={s.uri === selected} />
		});
		let mywidgets = (myitems || []).filter(x => !!x).map( s => { 
			return <ZooTopWidget key={s.uri} item={s} onWidgetMenu={this.onWidgetMenu} selected={s.uri === selected} />
		});
		return (
			<div className="ZooTop" onClick={this.closeMenus} onContextMenu={this.onBackgroundMenu}>
				<div className="ZooTopContent ClearFix">
					<div className="ZooTopContentRow ClearFix">{widgets}</div>
					<div className="ZooTopContentRow ClearFix">{mywidgets}</div>
				</div>
				<ZooTopTaskBar myitems={myitems || []} />
			</div>
		);
	}

}
class ZooTopWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { item, onWidgetMenu, selected } = this.props;

		let is_app = item.kind === "service";
		let is_playable = is_app && item.deployed;
		let has_img = item.thumb;
		let COLORS = { service: "ZooTopWidgetService", "default": "ZooTopWidgetDefault" };
		let bg = has_img ? "#fff" : (COLORS[item.kind] || COLORS["default"]);
		return (
			<a key={item.uri} data-tooltip={item.name} onClick={ROUTER.pushRoute.bind(ROUTER, "/zoo/" + item.uri + "?view=" + (is_playable ? "play" : "profile"))} href={"/zoo/" + item.uri} className="ZooTopWidget ZToolTip ZToolTipTop" onContextMenu={e => onWidgetMenu(item, e)}>
				<div className={"ZooTopWidgetThumb " + bg} >
					{AMC.getNodeThumbElement(item, "ZooTopWidgetThumbImg")}
					{ is_playable ? 
						<div className="ZooTopWidgetPlayButton ZooPlayButton CENTEREDPART"> </div>
					: '' }
					{ selected ? <div className="ZooTopWidgetSelected"></div> : '' }
				</div>
				{ item.state === "error" ? <div className="ZooTopWidgetError"><FontAwesomeIcon icon={faExclamationTriangle} /></div> : '' }
				<div className="ZooTopWidgetName">{item.name}</div>
			</a>
		);
	}
}

export class ZooTopTaskBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		window.addEventListener('resize', this.onResize);
		this.loadMyItems( (err, myitems) => {
			this.setState({ myitems: myitems });
			let prefer = document.body.clientWidth/100;
console.log("taskbar thigns.length: " + myitems.length);
console.log("taskbar prefer =" + prefer);
			if (myitems.length < prefer) {
				AMC.loadDemos((err, list) => {
console.log("taskbar demos loaded");
					this.setState({ demos: list });
				});
			}
		});
	}

	loadMyItems = (callback) => {
		let { myitems } = this.props;
		if (!myitems) {
			AMC.loadMyThings(callback);
		} else {
			callback(null, myitems);
		}
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}
	onResize = () => {
		this.forceUpdate();
	}
	render() {
		let { myitems, demos } = this.state;
		let DEFAULTS = [];
		let ICON_WIDTH = 13*1.5;
		let SPACING = 17;
		let tabs = (myitems || []).concat(demos || []); 
		let selected_uri = ZProps.get("path").split("/").slice(2).join("/");
		let numitems = Math.max(1, tabs.length);
console.log("taskbar render numitems=" + numitems);
		let maxwidth = (document.body.clientWidth - numitems*SPACING)/(1 + numitems);
		maxwidth -= ICON_WIDTH;
		let style = { width: maxwidth + "px" };
		return (
			<div className="ZooTopTaskBar">
				<ul>
				{ DEFAULTS.map( d => {
					return <li><div className="ZooTopTaskBarSpecialIcon">{d.icon}</div></li>;
				}) }
				{ tabs.map( item => {
					let is_app = item.kind === "service";
					let is_playable = is_app && item.deployed;
					return <li key={item.uri} className={"ZToolTip ZToolTipTop" + (item.uri === selected_uri ? " ZooTopTaskBarTabSelected" : "")} data-tooltip={item.name} ><a onClick={ROUTER.pushRoute.bind(ROUTER, "/zoo/" + item.uri + "?view=" + (is_playable ? "play" : "profile"))} href={"/zoo/" + item.uri}><div className="ZooTopTaskBarIcon">{AMC.getNodeThumbElement(item, "ZooTopTaskBarIconImg")}</div><div className="ZooTopTaskBarName" style={style}>{item.name}</div></a></li>;
				}) }
				</ul>
			</div>
		);
	}
}





class ZooTopWidgetMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
		let { context } = this.props;
		let item = context.item;
		this.MENU_OPTIONS = [];
		let user = ZProps.get("user");
console.error("item=" + ZUtil.inspect(item));
		if (item.kind === "service" && item.deployed) {
			this.MENU_OPTIONS.push(
				{ label: "play", type: "play", icon: <FontAwesomeIcon icon={faPlay} /> },
			);
		}
		this.MENU_OPTIONS.push(
			{ label: "profile", type: "profile", icon: <FontAwesomeIcon icon={faUserNinja} /> },
		);
		this.MENU_OPTIONS.push(
			{ label: "open in new tab", type: "openinnewtab", icon: <FontAwesomeIcon icon={faExternalLinkAlt} /> },
		);
		if (item.group === user.group) {
			this.MENU_OPTIONS.push(
				{ label: "edit", type: "edit", icon: <FontAwesomeIcon icon={faEdit} /> },
			);
		}
		this.MENU_OPTIONS.push(
			{ label: "inspect", type: "inspect", icon: <FontAwesomeIcon icon={faList} /> },
		);
		this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
			{ label: "separator" },
			{ label: "clone and edit", type: "clone", icon: <FontAwesomeIcon icon={faCodeBranch} /> },
		]);

	}
	onClick(type, e) {
		e.preventDefault();
		e.stopPropagation();
		let { context, ed } = this.props;
		let item = context.item;
		ed.closeMenus();
		switch (type) {
			case "play" :
				ROUTER.pushRoute("/zoo/" + item.uri + "?view=play");
				break;
			case "edit" :
				ROUTER.pushRoute("/zoo/" + item.uri + "?view=edit");
				break;
			case "profile" :
				ROUTER.pushRoute("/zoo/" + item.uri + "?view=profile");
				break;
			case "inspect" :
				ROUTER.pushRoute("/zoo/" + item.uri + "?view=inspect");
				break;
			case "openinnewtab" :
				window.open("/zoo/" + (item.kind === "service" || item.kind === "modelsource" ? item.uri : item.type));
				break;
			case "clone" :
				AMC.clone(item.uri, function(err, new_uri) {
					if (!err) {
						ROUTER.pushRoute("/zoo/" + new_uri);
					}
				});
				break;
			default:
				ZLog.error("ZooTopWidgetMenu unknown option=" + type);
				break;
		}
	}
	render() {
		let { context } = this.props;
		let menuitems = this.MENU_OPTIONS.map( (x, index) => { 
			return <RockContextMenuItem key={x.label + index} disabled={x.type === "paste" && !ZProps.get("clipboard")} onClick={this.onClick.bind(this, x.type)} icon={x.icon} label={x.label} keystroke={x.keystroke} /> 
		})
		let style = { left: context.x + "px", top: context.y + "px" };
		return (
			<div className="RockContextMenu" style={style}>
				{menuitems}
			</div>
		)
	}
}

class ZooTopBackgroundMenu extends React.Component {
	constructor(props) {
		super(props);
		let { context } = this.props;
		let transman = context.transman;
		this.state = { };
		this.MENU_OPTIONS = [
			{ label: ZProps.get("theme").name, type: "theme", icon: <FontAwesomeIcon icon={faRedoAlt} />, keystroke: <FontAwesomeIcon icon={faArrowRight} /> },
		];
		if (transman.hasUndo() || transman.hasRedo()) {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "separator" },
			]);
		}
		if (transman.hasUndo()) {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "undo", type: "undo", icon: <FontAwesomeIcon icon={faUndoAlt} />, keystroke: "Ctrl-Z" },
			]);
		}
		if (transman.hasRedo()) {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "redo", type: "redo", icon: <FontAwesomeIcon icon={faRedoAlt} />, keystroke: "Ctrl-Y" },
			]);
		}

	}
	onClick(type, e) {
		e.preventDefault();
		e.stopPropagation();
		let { ed } = this.props;
		ed.closeMenus();
		switch (type) {
			case "expand" :
				ed.onExpandAll();
				break;
			case "compress" :
				ed.onCompressAll();
				break;
			case "theme" :
				AMC.cycleTheme();
				break;
			case "undo" :
				ed.onUndo();
				break;
			case "redo" :
				ed.onRedo();
				break;
			default:
				ZLog.error("RockBackgroundContextMenu unknown type=" + type);
				break;
		}
	}
	render() {
		let { context } = this.props;
		let menuitems = this.MENU_OPTIONS.map( (x, index) => { 
			return <RockContextMenuItem key={x.label + index} disabled={x.type === "paste" && !ZProps.get("clipboard")} onClick={this.onClick.bind(this, x.type)} icon={x.icon} label={x.label} keystroke={x.keystroke} /> 
		})
		let style = { left: context.x + "px", top: context.y + "px" };
		return (
			<div className="RockContextMenu" style={style}>
				{menuitems}
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/ZooTop.js